import { useState } from 'react';
import { t } from 'utilities/TranslationUtils';
import FilterPill from 'pages/Sessions/components/FilterPill';
import FilterPopover from 'pages/Sessions/components/FilterPopover';

interface Props {
  layouts: ReadonlyArray<[id: string, name: string]>;
  selectedId: string;
  onSelect: (layoutId: string) => void;
}

/** Zone-layout filter: a pill in the kicks card's filter row that opens a single-choice picker (same look as the result pill). */
export default function LayoutFilterPill({ layouts, selectedId, onSelect }: Props) {
  const [open, setOpen] = useState(false);
  if (layouts.length < 2) return null;
  const current = layouts.find(([id]) => id === selectedId)?.[1] ?? layouts[0][1];
  return (
    <FilterPill label={current} open={open} onToggle={() => setOpen((v) => !v)} dataTest='pp-layout-filter'>
      <FilterPopover
        single
        title={t('playerPerformance.zoneLayout')}
        options={layouts.map(([value, label]) => ({ value, label }))}
        selected={[selectedId]}
        onChange={([id]) => { if (id) onSelect(id); }}
        onClose={() => setOpen(false)}
      />
    </FilterPill>
  );
}
